<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-12 text-center mb-4">
                <h1>Alerts</h1>
            </div>
        </div>
        <div v-if="loading" class="col-md-12 text-center mb-4">Loading...</div>
        <div v-else-if="alerts.length > 0" class="row">
            <p class="col-md-12 text-center mb-4">
                This screen contains a repository of messages you’ve previously viewed which are stored here for
                historic reference
            </p>
            <table class="table table-bordered table-striped">
                <thead class="table-dark">
                    <tr class="text-center">
                        <th>Date</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="alert in alerts" :key="alert.AlertID">
                        <td>{{ useDateFormatter(alert.DateCreated) }}</td>
                        <td v-html="alert.Message"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="row">
            <p class="col-md-12 text-center mb-4"> No archived alerts</p>
        </div>
    </div>
</template>

<script lang="ts">
import { Ref, onMounted, ref } from 'vue';
import { useDateFormatter } from "@utils/dateFormatter";
import axios from 'axios';

interface Alert {
    AlertID: number;
    AlertRead: string;
    AlertTypeID: string;
    DateCreated: string;
    DocumentID: number | null;
    FundType: string | null;
    Message: string;
    UIUserID: string;
}

export default {
    setup() {
        const loading = ref(false);
        const alerts: Ref<Alert[] | []> = ref([]);

        const fetchData = async () => {
            loading.value = true;

            await axios.get('api/participant/alerts/archived')
                .then(response => {
                    alerts.value = response.data;
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });

            loading.value = false;
        };

        onMounted(async () => {
            await fetchData();
        });

        return {
            alerts,
            loading,
            useDateFormatter
        };
    },
};
</script>